/* Banky Nieuw WP6.3: vergelijktabel op de productpagina (sections/banky-product-compare.liquid, PLAN.md #71).
   1. De toestelrij volgt de rekenhulp (banky-charge-calculator.js): na een keuze daar (event banky:toestel, of de keuze
      die de rekenhulp bij het laden uit localStorage terugzet) toont de rij dezelfde toestelnaam en per kolom de uitkomst
      voor dat toestel. De uitkomsten staan al in de HTML (data-uitkomsten per cel, in de volgorde van de toestellenlijst,
      vooraf berekend met A's model); hier wordt niets gerekend. Kies je een laptop, dan wijkt de rij van de
      laptopreferentie (anders staat dezelfde vraag er twee keer). Laptopregel met G13 (01-10-2026): een uitkomst "m1,5"
      toont "tot circa 1,5x" met daaronder "Minimaal vermogen", zoals Liquid de cel bouwt.
   2. "Vergelijk meer modellen" linkt in de HTML naar de vergelijkpagina zonder parameters (PLAN.md §3.16: geen
      parameterlinks in de HTML, de canonical blijft de pagina); pas bij het klikken komen de producten uit de tabel
      erachter (?p=a,b,c), zoals de vergelijkbalk van WP6.1 dat doet (PLAN.md #66). */
(() => {
  if (window.bankyProductCompare) return;
  window.bankyProductCompare = true;
  const LAPTOPGROEPEN = ['macbook', 'windows'];
  const vul = (sjabloon, sleutel, waarde) => String(sjabloon || '').split('[' + sleutel + ']').join(waarde);

  function zetToestel(detail) {
    if (!detail || !Number.isInteger(detail.index) || detail.index < 0) return;
    document.querySelectorAll('[data-banky-pdp-vergelijk]').forEach(blok => {
      const rij = blok.querySelector('[data-banky-pdp-vergelijk-toestelrij]');
      if (!rij) return;
      const cellen = [...rij.querySelectorAll('td[data-uitkomsten]')];
      const waarden = cellen.map(td => (td.dataset.uitkomsten || '').split(';')[detail.index] || '');
      // Een kolom zonder uitkomst (vermogen onbekend): rij verbergen, zoals Liquid een onvolledige rij weglaat.
      if (!cellen.length || waarden.some(w => !w || w === 'o')) { rij.hidden = true; }
      else {
        const kop = rij.querySelector('th[data-sjabloon]');
        if (kop) kop.textContent = vul(kop.dataset.sjabloon, 'toestel', detail.naam || '');
        cellen.forEach((td, i) => {
          if (waarden[i] === 't') {
            td.textContent = '';
            const zwak = document.createElement('span');
            zwak.className = 'banky-pdp-vergelijk__zwak';
            zwak.textContent = blok.dataset.tekstTeWeinig || '';
            td.appendChild(zwak);
          } else if (waarden[i].charAt(0) === 'm') {
            td.textContent = vul(blok.dataset.tekstAantal, 'aantal', waarden[i].slice(1));
            const noot = document.createElement('span');
            noot.className = 'banky-pdp-vergelijk__minimaal';
            noot.textContent = blok.dataset.tekstMinimaal || '';
            td.appendChild(noot);
          } else {
            td.textContent = vul(blok.dataset.tekstAantal, 'aantal', waarden[i]);
          }
        });
        rij.hidden = false;
      }
      const laptoprij = blok.querySelector('[data-banky-pdp-vergelijk-laptoprij]');
      if (laptoprij) laptoprij.hidden = LAPTOPGROEPEN.includes(detail.groep);
    });
  }

  document.addEventListener('banky:toestel', e => zetToestel(e.detail));
  // De rekenhulp staat boven de tabel en laadt eerder: neem zijn huidige keuze over (ook een bewaarde keuze).
  const start = () => {
    const keuze = document.querySelector('[data-banky-rekenhulp-toestel]');
    const o = keuze && keuze.selectedOptions[0];
    if (o && !o.defaultSelected) zetToestel({index: Number(o.dataset.index), naam: o.textContent.trim(), groep: o.dataset.groep || ''});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  document.addEventListener('click', e => {
    const link = e.target.closest && e.target.closest('a[data-banky-pdp-vergelijk-meer]');
    if (!link) return;
    const handles = (link.dataset.bankyPdpVergelijkMeer || '').split(',').filter(Boolean).slice(0, 3);
    if (handles.length < 2) return;
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('p', handles.join(','));
    link.href = url.pathname + url.search;
  });
})();
